import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, Select, Space } from "@mantine/core";
import { IoMdAdd } from "react-icons/io";
import { Hotel, PlaneTakeoff } from "lucide-react";

import "@mantine/dates/styles.css";

import PageLayout from "PageLayout";
import useMaster from "hook/useMaster";
import { getRole } from "utils/routeUtility";
import { IMarkupB2CFilter, TChargeUserType } from "types";
import { EButton, EPageTitle } from "libs/ui";

import HotelMarkList from "./Listing/HotelMarkList";
import FlightMarkList from "./Listing/FlightMarkupList";


export default function MarkupB2B() {

  const navigate = useNavigate();
  const { state } = useLocation();
  const { service } = state || {};


  const {
    getServiceTypes,
    serviceTypes,
    supplierList,
    getSupplierList
  } = useMaster();


  const [userChargeType, setUserChargeType] = useState<TChargeUserType>("AFFILIATE");
  const [filter, setFilter] = useState<IMarkupB2CFilter>({
    service: service ? service : "FLIGHT",
    suppliers: "",
    startDate: null,
    endDate: null,
  });


  useEffect(() => {
    if (filter.service) {
      getServiceTypes();
      getSupplierList(filter.service);
    };
  }, [filter.service]);


  // HANDLER FUNCTIONS
  const handleFilterChange = (
    key: keyof IMarkupB2CFilter | "default",
    value: string | null
  ) => {
    if (key === "default") {
      setFilter({} as IMarkupB2CFilter);
    } else {
      setFilter((prev) => ({ ...prev, [key]: value }));
    };
  };


  return (
    <PageLayout>
      <EPageTitle
        title="Markup B2B"
        end={
          <Menu withArrow shadow="md" trigger="hover" position="bottom-end" width={200}>
            <Menu.Target>
              <div>
                <EButton
                  rightSection={<IoMdAdd />}
                // onClick={() => {
                //   navigate("/admin-transaction/create-markup-b2c", {
                //     replace: false,
                //     state: { service },
                //   });
                // }}
                >
                  Create New
                </EButton>
              </div>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Markup for</Menu.Label>
              <Menu.Item
                leftSection={<PlaneTakeoff size={14} />}
                onClick={() => {
                  navigate(`/admin-transactions/markup_and_commission/markup/b2b/flight/${userChargeType}`);
                }}
              >
                Flight
              </Menu.Item>
              <Menu.Item
                leftSection={<Hotel size={14} />}
                onClick={() => {
                  navigate(`/admin-transactions/markup_and_commission/markup/b2b/hotel/${userChargeType}`);
                }}
              >
                Hotel
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        }
      />

      {/* Filter */}
      <div className="filter-container">
        <div className="w-full grid grid-cols-4 gap-3">
          <Select
            label="Service"
            size="md"
            placeholder="Select"
            data={serviceTypes || []}
            value={filter.service}
            onChange={(value) => handleFilterChange("service", value)}
          />
          {/* <Select
            label="Suppliers"
            size="md"
            placeholder="Select"
            data={supplierList || []}
            value={filter.suppliers}
            onChange={(value) => handleFilterChange("suppliers", value)}
          />
          <EDateInput
            clearable
            label="Start Date"
            placeholder="Pick date"
            minDate={new Date()}
            value={filter.startDate ? new Date(filter.startDate) : null}
            onChange={(value) => {
              handleFilterChange("endDate", null);
              handleFilterChange("startDate", value?.toString() || null);
            }}
          />
          <EDateInput
            label="End Date"
            placeholder="Pick date"
            disabled={!filter.startDate}
            value={filter.endDate ? new Date(filter.endDate) : null}
            minDate={filter.startDate ? new Date(filter.startDate) : new Date()}
            onChange={(value) =>
              handleFilterChange("endDate", value?.toString() || null)
            }
          /> */}
        </div>
        {/* <div className="flex w-full justify-end gap-2">
          <EButton
            onClick={() => {
              setFilter({
                service: "FLIGHT",
                suppliers: "",
                startDate: null,
                endDate: null,
              });
            }}
            color="gray"
          >
            Cancel
          </EButton>
          <EButton onClick={() => getMarkupList("INITIAL_PAGE")}>Search</EButton>
        </div> */}
      </div>

      <Space h="xl" />
      {
        filter.service === "HOTEL"
          ?
          <HotelMarkList userChargeType={userChargeType} />
          :
          <FlightMarkList userChargeType={userChargeType} />
      }
    </PageLayout>
  );
}
